var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagEu = function SvgFlagEu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-eu_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.78.577h-50v34h50v-34Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.78 4.354-.572 1.797.881.292-.308-2.089Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.78 4.354.573 1.797-.88.292.308-2.089Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.543 5.66-1.848.008-.004.936 1.852-.944Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.543 5.655 26.04 6.77l-.54-.76 2.043-.355Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.87 7.769-.57-1.794-.883.294 1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.867 7.771-1.495-1.107.546-.767.95 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.02 5.66 1.848.008.004.936-1.852-.944Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.02 5.655 1.502 1.115.54-.76-2.042-.355Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.693 7.769.569-1.794.884.294-1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.695 7.771 1.496-1.107-.547-.767-.949 1.874ZM25.78 27.021l-.572 1.796.881.292-.308-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.78 27.021.573 1.796-.88.292.308-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.543 28.326-1.848.009-.004.936 1.852-.945Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.543 28.322-1.503 1.114-.54-.76 2.043-.354Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.87 30.436-.57-1.794-.883.294 1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.867 30.438-1.495-1.107.546-.767.95 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.02 28.326 1.848.009.004.936-1.852-.945Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.02 28.322 1.502 1.114.54-.76-2.042-.354Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.693 30.436.569-1.794.884.294-1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.695 30.438 1.496-1.107-.547-.767-.949 1.874ZM14.67 15.688l-.573 1.796.88.292-.308-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.67 15.688.572 1.796-.88.292.307-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.431 16.993-1.847.009-.005.935 1.852-.944Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.431 16.988-1.502 1.115-.54-.76 2.042-.355Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.758 19.102-.568-1.794-.885.295 1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.756 19.105-1.496-1.108.547-.767.949 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.909 16.993 1.847.009.005.935-1.852-.944Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.909 16.988 1.502 1.115.54-.76-2.042-.355Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.582 19.102.568-1.794.884.295-1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.584 19.105 1.496-1.108-.547-.767-.949 1.875ZM19.14 9.29l1.495-1.108-.547-.767-.948 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.137 9.287.569-1.794.884.295-1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.464 7.175 1.5 1.113.543-.762-2.043-.35Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.464 7.178 1.85.005.002.94-1.852-.945Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.222 5.873-.569 1.794.885.294-.316-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.222 5.873.576 1.799-.877.289.301-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.315 9.29-1.5-1.113.542-.762.958 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.314 9.292-.576-1.799-.877.29 1.453 1.509Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.986 7.18 20.49 8.288l-.546-.766 2.042-.342Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.984 7.182-1.85-.004.002.94 1.848-.936ZM17.247 13.435l-.569-1.793-.884.294 1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.244 13.438-1.495-1.107.546-.767.95 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.068 13.438 1.5-1.113-.541-.761-.959 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.07 13.44.576-1.799.877.29-1.453 1.51Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.398 11.328 1.496 1.108.546-.766-2.043-.342Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.4 11.33 1.85-.004-.003.94-1.848-.936Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.92 11.324-1.5 1.112-.543-.761 2.042-.351Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.92 11.326-1.85.005-.002.94 1.851-.945Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.162 10.021.568 1.794-.884.294.316-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.162 10.021-.576 1.799.877.29-.301-2.089ZM17.92 22.66l-1.846.012-.006.932 1.852-.945Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.92 22.653-1.504 1.117-.539-.758 2.043-.359Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.247 24.765-.563-1.79-.89.298 1.453 1.492Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.24 24.771-1.49-1.102.55-.772.94 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.066 24.771 1.502-1.114-.54-.76-.962 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.07 24.776.578-1.801.875.288-1.453 1.512Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.166 21.354.565 1.791-.888.298.323-2.089Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.166 21.354-.58 1.803.873.286-.293-2.089Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.4 22.665 1.85-.005-.003.939-1.847-.934Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.398 22.662 1.495 1.108.547-.767-2.043-.34ZM21.987 26.808l-1.846.012-.006.932 1.852-.944Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.987 26.801-1.504 1.117-.539-.758 2.043-.359Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.314 28.913-.563-1.79-.89.299 1.453 1.491Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.308 28.92-1.492-1.103.55-.772.942 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.133 28.92 1.502-1.115-.54-.76-.962 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.137 28.924.578-1.8.875.287-1.453 1.513Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.233 25.503.565 1.79-.888.298.323-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.233 25.503-.58 1.802.873.286-.293-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.467 26.813 1.85-.005-.003.94-1.847-.935Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.464 26.81 1.496 1.108.547-.767-2.043-.34ZM36.893 15.688l.572 1.796-.88.292.308-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.893 15.688-.573 1.796.88.292-.307-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.13 16.993 1.848.009.005.935-1.852-.944Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.13 16.988 1.503 1.115.54-.76-2.042-.355Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.804 19.102.569-1.794.884.295-1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.806 19.105 1.496-1.108-.547-.767-.949 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.653 16.993-1.847.009-.005.935 1.852-.944Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.653 16.988-1.502 1.115-.54-.76 2.042-.355Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.98 19.102-.568-1.794-.884.295 1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.978 19.105-1.496-1.108.547-.767.949 1.875ZM32.422 9.29l-1.495-1.108.547-.767.948 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.425 9.287-.569-1.794-.884.295 1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.098 7.175-1.5 1.113-.543-.762 2.043-.35Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.098 7.178-1.85.005-.002.94 1.852-.945Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.34 5.873.569 1.794-.885.294.316-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.34 5.873-.576 1.799.877.289-.301-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.247 9.29 1.5-1.113-.542-.762-.958 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.248 9.292.576-1.799.877.29-1.453 1.509Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.576 7.18 1.496 1.108.546-.766-2.042-.342Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.578 7.182 1.85-.004-.002.94-1.848-.936ZM34.315 13.435l.569-1.793.884.294-1.453 1.5Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.318 13.438 1.495-1.107-.546-.767-.95 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.494 13.438-1.5-1.113.541-.761.959 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.492 13.44-.576-1.799-.877.29 1.453 1.51Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.165 11.328-1.497 1.108-.546-.766 2.043-.342Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.163 11.33-1.85-.004.002.94 1.848-.936Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.643 11.324 1.5 1.112.542-.761-2.042-.351Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.643 11.326 1.85.005.001.94-1.851-.945Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.4 10.021-.568 1.794.884.294-.316-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.4 10.021.576 1.799-.877.29.301-2.089ZM33.642 22.66l1.846.012.006.932-1.852-.945Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.642 22.653 1.504 1.117.538-.758-2.042-.359Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.315 24.765.563-1.79.89.298-1.453 1.492Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.321 24.771 1.492-1.102-.55-.772-.942 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.496 24.771-1.502-1.114.54-.76.962 1.874Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.492 24.776-.578-1.801-.875.288 1.453 1.512Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.395 21.354-.564 1.791.888.298-.324-2.089Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.396 21.354.58 1.803-.873.286.293-2.089Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.162 22.665-1.85-.005.003.939 1.847-.934Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.165 22.662-1.496 1.108-.547-.767 2.043-.34ZM29.575 26.808l1.846.012.006.932-1.852-.944Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.575 26.801 1.504 1.117.539-.758-2.043-.359Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.248 28.913.563-1.79.89.299-1.453 1.491Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.254 28.92 1.492-1.103-.55-.772-.942 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.43 28.92-1.503-1.115.54-.76.962 1.875Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.425 28.924-.578-1.8-.875.287 1.453 1.513Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.329 25.503-.565 1.79.889.298-.324-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.33 25.503.579 1.802-.873.286.293-2.088Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.095 26.813-1.85-.005.003.94 1.847-.935Z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.098 26.81-1.496 1.108-.547-.767 2.043-.34Z",
    fill: "#FC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-eu_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.78 .577)",
    d: "M0 0h50v34H0z"
  })))));
};
export default SvgFlagEu;